import React, { forwardRef, useMemo } from 'react';
import { MaterialDesignContent, closeSnackbar, CustomContentProps } from 'notistack';

import { useDismissibleIconSnackbarStyles } from './DismissibleIconSnackbarContent.styles';

/**
 * Same as notistack's default content, but clicking the variant icon dismisses the snackbar.
 */
export const DismissibleIconSnackbarContent = forwardRef<HTMLDivElement, CustomContentProps>(
  function DismissibleIconSnackbarContent (props, ref) {
    const classes = useDismissibleIconSnackbarStyles();
    const { id, iconVariant } = props;

    const wrappedIconVariant = useMemo(() => {
      if (!iconVariant) {
        return iconVariant;
      }
      const entries = Object.entries(iconVariant).map(([key, icon]) => {
        if (!icon) {
          return [key, icon];
        }
        return [
          key,
          <span
            key={key}
            role="button"
            aria-label="Dismiss notification"
            tabIndex={0}
            onClick={e => {
              e.stopPropagation();
              closeSnackbar(id);
            }}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                closeSnackbar(id);
              }
            }}
            className={classes.dismissIconButton}
          >
            {icon}
          </span>,
        ];
      });
      return Object.fromEntries(entries) as typeof iconVariant;
    }, [classes.dismissIconButton, iconVariant, id]);

    return <MaterialDesignContent {...props} ref={ref} iconVariant={wrappedIconVariant} />;
  },
);
